import { FormattedMessage } from 'react-intl';

import { Tabs, Tab, TabList, TabPanel } from 'ui-components/components/tabs';

import { TOTES_TAB_CLICKED } from '../../../../constants/analytics-events';
import { ManageLocationsTab } from './manage-locations-tab';
import messages from '../messages';
import { Segment } from '../../../../services/analytics-services/segment';
import style from './style.module.less';
import { useEnablePickToTote } from '../../../../feature-flags/hooks/use-pick-to-tote';
import { TotesTable } from '../totes-table';

/**
 * ConfigureWarehouseTabs Component. This component renders a tabbed interface for configuring warehouse settings.
 * It includes tabs for locations and totes, with the latter being conditionally rendered based on feature flags.
 * @param {object} props - The component props.
 * @param {string} props.inventoryWarehouseId - The ID of the inventory warehouse.
 * @param {string} props.inventoryWarehouseName - The name of the inventory warehouse.
 * @param {() => void} props.onCreateTotes - Callback function to handle the creation of totes.
 * @param {number} props.selectedTabIndex - The currently selected tab index.
 * @param {(index: number) => void} props.setSelectedTabIndex - Callback to update the selected tab index.
 * @returns {JSX.Element} The rendered tabs component.
 */
const ConfigureWarehouseTabs = ({ inventoryWarehouseId, inventoryWarehouseName, onCreateTotes, selectedTabIndex, setSelectedTabIndex }) => {
  const isTotesTabEnabled = useEnablePickToTote();
  return (
    <Tabs onSelect={setSelectedTabIndex} selectedIndex={selectedTabIndex}>
      <TabList>
        <Tab className={style['tab-item']} selectedClassName={style['selected-tab-item']}>
          <FormattedMessage {...messages.manageLocationsDrawerTabTitleLocations} />
        </Tab>
        {isTotesTabEnabled && (
          <Tab
            className={style['tab-item']}
            onClick={() =>
              Segment.trackEvent(TOTES_TAB_CLICKED, {
                warehouseId: inventoryWarehouseId,
              })
            }
            selectedClassName={style['selected-tab-item']}
          >
            <FormattedMessage {...messages.manageLocationsDrawerTabTitleTotes} />
          </Tab>
        )}
      </TabList>
      <TabPanel>
        <ManageLocationsTab inventoryWarehouseId={inventoryWarehouseId} inventoryWarehouseName={inventoryWarehouseName} />
      </TabPanel>
      {isTotesTabEnabled && (
        <TabPanel>
          <TotesTable inventoryWarehouseId={inventoryWarehouseId} onCreateTotes={onCreateTotes} />
        </TabPanel>
      )}
    </Tabs>
  );
};

export { ConfigureWarehouseTabs };
